import { useEffect, useState } from 'react';
import { MOBILE_WIDTH } from '../constants';

// will be updated after first render to help with server/client mismatch
let defaultWidth = 0;

const useCheckMobileScreen = () => {
  const { innerWidth: initialWidth = defaultWidth } = typeof window !== 'undefined' ? window : {};
  const [width, setWidth] = useState(defaultWidth);
  defaultWidth = width;

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    if (!defaultWidth) {
      setWidth(initialWidth);
    }
  }, [initialWidth, width]);

  return width <= MOBILE_WIDTH;
};

export default useCheckMobileScreen;
